import script from "./AdminFunerariaDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFunerariaDashboard.vue?vue&type=script&setup=true&lang=js"

import "./AdminFunerariaDashboard.vue?vue&type=style&index=0&id=71d485d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71d485d2"]])

export default __exports__